import CreateQuestionForm from '../../../components/questions/create-question/create-question-form.tsx';
import { useSearchParams } from 'react-router-dom';

const CreateQuestion = () => {
  const [params] = useSearchParams();

  return (
    <div className={'flex items-center justify-center'}>
      <div className={'w-[656px] max-w-[656px]'}>
        <h1>SAT: create question</h1>
        <p className={'description'}>*required field</p>
        <CreateQuestionForm params={params} />
      </div>
    </div>
  );
};
export default CreateQuestion;
